import { CheckoutPage } from "./checkout.component";
import { connect } from "react-redux";
import {
  createOrder,
  confirmOrder,
  applyCoupon,
  createOrderCOD,
  resetOrderState,
  fetchOrders,
} from "./../../api/order/orderAction";

const mapDispatchToProps = {
  createOrder,
  confirmOrder,
  applyCoupon,
  createOrderCOD,
  resetOrderState,
  fetchOrders,
};

const mapStateToProps = (state) => ({
  isLoading: state.orderPage.isLoading,
  order: state.orderPage.order,
  isConfirmed: state.orderPage.isConfirmed,
  confirmedOrder: state.orderPage.confirmedOrder,
  loggedUser: state.userPage.loggedUser,
  cart: state.cartPage.cart,
  coupon: state.orderPage.coupon,
  orders: state.orderPage.orders,
});

export const CheckoutContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CheckoutPage);
